module.exports = __webpack_public_path__ + "img/cloud-iso-en.43aee94f.png";